<div class="base-component padding">
  <div class="compromise-item">
    <div class="clickable" (click)="toggleEventCompletion()">
      <mat-icon>
        {{ item.is_complete ? 'event_available' : 'calendar_today' }}
      </mat-icon>
    </div>

    <h4 style="margin-left:1px;" class="title text-center text-hard-blue">{{ showName }}</h4>

    <svg height="20" width="60">
      <line x1="13" x2="50" y1="13" y2="13" style="stroke:#28306e;stroke-width:3" />
    </svg>

    <p
      *ngIf="item.limit_date"
      class="compromise-item-date"
    >
      {{ item.limit_date }}
    </p>
  </div>
  <div class="compromise-item-description" [innerHTML]="item.description"></div>
</div>
